import React, { useState } from 'react'
import {
  MDBNav,
  MDBNavItem,
  MDBNavLink,
  MDBTabContent,
  MDBTabPane,
} from 'mdbreact'
import { HashLink } from 'react-router-hash-link'
import QuotePopupModal from './../modals/QuotePopupModal/QuotePopupModal.component'

const getHash = (str) =>
  `quote-${str === 'small' ? 'small-biz' : str}-insurance`

const InsuranceType = (props) => {
  const [activeItem, setActiveItem] = useState(0)

  const toggle = (tab) => (e) => {
    if (activeItem !== tab) setActiveItem(tab)
  }

  const renderTab = () => {
    return (
      <>
        <MDBNav className="nav-tabs">
          {props.insurances.map((m, i) => (
            <MDBNavItem
              key={'it-i-' + i}
              className={activeItem === i ? 'active' : ''}
            >
              <MDBNavLink
                link
                to="#"
                active={activeItem === i}
                onClick={toggle(i)}
                role="tab"
              >
                <span className={'tab-insurance'}>
                  <span className={`fas ${m.icon} fa-4x`}></span>
                  &nbsp;&nbsp;
                  <span className="text-spacing-50">{m.name}</span>
                </span>
              </MDBNavLink>
            </MDBNavItem>
          ))}
        </MDBNav>
        <MDBTabContent activeItem={activeItem}>
          {props.insurances.map((m, i) => (
            <MDBTabPane key={'it-t-' + i} className="in fade" tabId={i}>
              <div className="tab-content-inner">
                <div>
                  <div>
                    <div>
                      <h5>{m.name}</h5>
                      <p>{m.description}</p>
                      <div style={{ padding: '2px', color: '#666' }}>
                        <small>
                          Not available in all states, including New York.
                        </small>
                      </div>
                    </div>
                    <HashLink
                      to={`/#${getHash(
                        m.name.split(' ').shift().toLowerCase()
                      )}`}
                      className="btn btn-icon btn-icon-right btn-cello-outline btn-custom offset-top-30"
                      style={{ marginTop: '15px' }}
                    >
                      <span className="icon icon-xs-smaller fa-angle-right"></span>
                      &nbsp; Get a Quote
                    </HashLink>
                  </div>
                </div>
                <div className="offset-top-30">
                  <figure className="image-wrap-default">
                    <img
                      src={m.image}
                      width="398"
                      height="311"
                      alt=""
                      className="img-responsive"
                    />
                  </figure>
                </div>
              </div>
            </MDBTabPane>
          ))}
        </MDBTabContent>
      </>
    )
  }

  return (
    <>
      <section
        id="InsuranceTypeComponent"
        style={{ backgroundColor: '#1A237E' }}
        className="section-50 section-sm-bottom-75 section-md-bottom-100"
      >
        <div className="shell">
          <div className="range offset-lg-top--35">
            <div className="cell-lg-12">
              <div
                id="tabs-2"
                className={`tabs-custom tabs-vertical tabs-corporate tabs-vertical-reverse bg-white shadow-panel`}
              >
                {renderTab()}
              </div>
            </div>
          </div>
        </div>
      </section>
      <QuotePopupModal insuranceType={props.insuranceType} autoOpen={false} />
    </>
  )
}

export default InsuranceType
